// @flow
import React from 'react';
import {
  compose,
  withProps,
  setDisplayName,
} from 'recompose';
import reactCSS from 'reactcss';
import { reduxForm } from 'redux-form';
import { ReduxFormSearchInputAdapter, Design as InputDesign } from './Input';
import { getStyles } from '@ux/style-utils';
import { gu2px, Curvature } from '@ux/theme-utils';
import cssSides, { Side } from '@team-griffin/css-sides';
import * as r from 'ramda';
import { createPaintbrushUrl } from '@ux/glyphs';
import DebouncedField from 'redux-form-debounce-field';

export { InputDesign as Design };

export const stylesheet = ({
  theme,
}) => {
  return {
    default: {
      form: {
        position: 'relative',
      },
      search: {
        position: 'absolute',
        top: 3,
        right: 3,
        bottom: 3,
        paddingLeft: gu2px(2, theme.spacing),
        backgroundImage: `
          linear-gradient(
            to left,
            rgba(255,255,255,1) 80%,
            rgba(255,255,255,0)
          )
        `,
        borderRadius: r.cond([
          [ r.propEq('curvature', Curvature.OFF), r.always(0) ],
          [ r.propEq('curvature', Curvature.WEAK), r.always(3) ],
          [ r.propEq('curvature', Curvature.STRONG), r.always(8) ],
        ])(theme),
        overflow: 'hidden',
      },
      searchButton: {
        ...cssSides('padding', Side.Y, gu2px(0, theme.spacing)),
        ...cssSides('padding', Side.X, gu2px(2, theme.spacing)),
        position: 'relative',
        height: '100%',
        cursor: 'pointer',
        backgroundColor: '#fff',
        borderWidth: 0,
        outline: 0,
      },
      searchIcon: {
        width: gu2px(3, theme.spacing),
        height: gu2px(3, theme.spacing),
        display: 'block',
      },
      buttonText: {
        display: 'flex',
        alignItems: 'center',
        height: '100%',
        justifyContent: 'center',
      },
    },

    isMinSm: {
      form: {
        marginBottom: 0,
        flex: 1,
        flexBasis: 'auto',
      },
      searchButton: {
        ...cssSides('padding', Side.X, gu2px(2, theme.spacing)),
      },
    },
  };
};

// eslint-disable-next-line no-shadow
export const stylesheetToStyles = (stylesheet, props) => reactCSS(stylesheet, {
  isMinSm: props.isMinSm,
}, props);

export const SearchButton = ({
  theme,
  styles,
  onClick,
}) => (
  <span style={styles.search}>
    <button
      type="submit"
      style={styles.searchButton}
      onClick={onClick}
    >
      <img
        style={styles.searchIcon}
        src={createPaintbrushUrl(
          'magnifyingGlass',
          [ theme.palette.secondary ]
        )}
        aria-hidden="true"
        alt="search"
      />
    </button>
  </span>
);

export const PureSearchForm = ({
  theme,
  form,
  styles,
  isMinSm,
  isMinMd,
  design,
}) => (
  <form
    onSubmit={form.handleSubmit}
    style={styles.form}
  >
    <DebouncedField
      name="query"
      component={ReduxFormSearchInputAdapter}
      theme={theme}
      isMinSm={isMinSm}
      isMinMd={isMinMd}
      design={design}
    />
    <SearchButton
      theme={theme}
      styles={styles}
    />
  </form>
);

export const enhance = compose(
  setDisplayName('SearchForm'),
  reduxForm({
    form: 'domainSearch',
    propNamespace: 'form',
    destroyOnUnmount: false,
  }),
  withProps((ownerProps) => ({
    styles: getStyles(stylesheet, stylesheetToStyles, ownerProps),
  })),
);

export default enhance(PureSearchForm);
